<template lang="pug">
v-card
  v-img(:src="imageUrl" :lazy-src="thumbnailUrl" class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.6)" height="150px")
    v-row.lightbox.white--text.fill-height.pl-8(align="end")
      v-col
        div.display-1 {{ trip.destination }}
  v-card-text
    v-list
      v-list-item
        span {{trip.trip_id}}
      v-list-item
        v-icon mdi-airplane-landing
        v-list-item-title.pl-2 Arrival: {{ trip.arrival_date }}  at {{ trip.arrival_time }}
      v-list-item
        v-icon mdi-airplane-takeoff
        v-list-item-title.pl-2 Return: {{ trip.return_date }}  at  {{ trip.return_time }}
    v-btn.primary(block depressed @click="$router.push({ name: 'trip', query: { trip_id: trip.trip_id }})") View Trip Details
</template>

<script>
export default {
  name: "TripItem",
  props: ['trip'],
  data: () => ({
  }),
  computed: {
    imageUrl () {
      if (this.trip.destination === 'Seoul') {
        return 'https://images.unsplash.com/photo-1553071820-9c15c8588ee8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=800&q=80'
      } else if (this.trip.destination === 'Jeju') {
        return 'https://images.unsplash.com/photo-1562680829-7927493f7a50?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80'
      } else {
        return ''
      }
    },
    thumbnailUrl () {
      if (this.trip.destination === 'Seoul') {
        return 'https://images.unsplash.com/photo-1553071820-9c15c8588ee8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&h=100&q=80'
      } else if (this.trip.destination === 'Jeju') {
        return 'https://images.unsplash.com/photo-1562680829-7927493f7a50?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=100&q=80'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>